import { gql } from '@apollo/client';
import { client } from '../client';
import { getAppVersion } from '../../utils/appRuntime';

export interface PdaScanSetting {
  accountId: string | number;
  warehouseId: string | number;
  masterEnabled: boolean;
  vibrateEnabled: boolean;
  breathingLightEnabled: boolean;
  soundEnabled: boolean;
  soundId: string;
  lastUpdatedByType: string;
}

export interface PdaPreference {
  scanSetting: PdaScanSetting | null;
}

export const GET_MY_PDA_PREFERENCE = gql`
  query GetMyPdaPreference($appVersion: String) {
    getMyPdaPreference(appVersion: $appVersion) {
      scanSetting {
        accountId
        warehouseId
        masterEnabled
        vibrateEnabled
        breathingLightEnabled
        soundEnabled
        soundId
        lastUpdatedByType
      }
    }
  }
`;

export async function getMyPdaPreference(): Promise<PdaPreference> {
  const appVersion = await getAppVersion();
  const resp = await client.query<{ getMyPdaPreference: PdaPreference }>({
    query: GET_MY_PDA_PREFERENCE,
    variables: { appVersion },
    fetchPolicy: 'network-only',
  });
  return resp.data?.getMyPdaPreference ?? { scanSetting: null };
}
